import { ReportGenerationAnimation } from '@components/icons/ReportGenerationAnimation'

import { ReportCard } from '@/components/Consultation/steps/Answer/ReportCard'
import { getSlugTranslation } from '@/locale/utils'

export const ReportLoading = () => {
  return (
    <div aria-busy="true" aria-live="polite" className="flex flex-1 items-start justify-center p-4" data-testid="report-loading" role="status">
      <ReportCard>
        <div className="flex flex-col items-center gap-8 py-12 text-center">
          <ReportGenerationAnimation />

          <div className="flex flex-col gap-2">
            <h2 className="text-base font-bold">{getSlugTranslation('general.consultation.loadingReport')}</h2>
            <p className="text-gray-text text-sm">{getSlugTranslation('general.consultation.loadingReport.waitingTime')}</p>
          </div>
        </div>
      </ReportCard>
    </div>
  )
}
